import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import ConsosTabsComponent from './ConsosTabsComponent'
import { withStyles } from '@material-ui/core/styles'
// import ListConsosComponent from './ListConsosComponent'
import SideBarConsosComponent from 'components/SideBarConsosComponent'
const styles = theme => ({
  container: {
    position: 'relative',
    overflow: 'hidden'
  }
})
class ProductsComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    products: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    selectedProducts: PropTypes.array.isRequired,
    addProduct: PropTypes.func.isRequired,
    removeProduct: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
    clearSelectedProducts: PropTypes.func.isRequired,
    changeReduc: PropTypes.func.isRequired
  }
  componentWillUnmount() {
    this.props.clearSelectedProducts()
  }
  render() {
    const { classes, products, categories, selectedProducts } = this.props
    if (categories.length === 0) return null
    return (
      <Grid
        className={classes.container}
        item
        container
        direction="row"
        alignItems="stretch"
        justify="flex-start"
        spacing={16}>
        <Grid item xs={12} sm={12} md={8}>
          <ConsosTabsComponent
            products={products}
            categories={categories}
            addConso={this.props.addProduct}
            size="large"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <SideBarConsosComponent
            validate
            showModal={this.props.showModal}
            changeReduc={this.props.changeReduc}
            allProducts={this.props.products}
            categories={this.props.categories}
            products={selectedProducts || []}
            addConso={this.props.addProduct}
            removeConso={this.props.removeProduct}
          />
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(styles)(ProductsComponent)



// WEBPACK FOOTER //
// ./src/routes/Products/components/ProductsComponent.js